"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Infrastructure() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const values = [{
    numeral: "I",
    title: "Global Node Network",
    description: "Deploy across 100+ high-speed server locations worldwide. Our infrastructure ensures minimal latency and maximum throughput for every connection."
  }, {
    numeral: "II",
    title: "Military-Grade Encryption",
    description: "We utilize AES-256 bit encryption protocols to secure your data traffic. Every packet is shielded from unauthorized access and surveillance."
  }, {
    numeral: "III",
    title: "Zero-Log Architecture",
    description: "Our RAM-only server clusters ensure no data is ever written to disk. Your browsing history remains private, anonymous, and completely untraceable."
  }, {
    numeral: "IV",
    title: "Scalable VPN Solutions",
    description: "Built for enterprise-level demand, our load-balanced infrastructure handles massive traffic spikes without compromising speed or security integrity."
  }];
  return <section data-section-id="3603" id="vpndeploymentinfrastructure" className="bg-background text-foreground py-[200px] px-6 md:px-10 lg:px-16 relative overflow-hidden">
      {}
      <div ref={headerRef} className={`max-w-7xl mx-auto mb-20 md:mb-28 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="grid grid-cols-12 gap-4 items-end">
          <div className="col-span-12 md:col-span-3">
            <span className="font-mono text-xs tracking-widest uppercase" style={{
            color: "var(--primary)"
          }}>
              03 / NETWORK
            </span>
          </div>
          <div className="col-span-12 md:col-span-9">
            <h2 className="font-default font-bold leading-[0.95] tracking-tight" style={{
            fontSize: "clamp(3rem, 8vw, 8rem)"
          }}>
              <span className="block text-foreground">SECURE</span>
              <span className="block font-serif italic font-light" style={{
              color: "var(--primary)"
            }}>
                backbone
              </span>
            </h2>
          </div>
        </div>
        <div className="mt-12 h-px w-full bg-border" />
      </div>

      {}
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
        {values.map((value, i) => {
        const isFourth = i === 3;
        return <ValueCard key={i} data-index={i} numeral={value.numeral} title={value.title} description={value.description} spanTwo={isFourth} />;
      })}
      </div>
    </section>;
}
function ValueCard({
  numeral,
  title,
  description,
  spanTwo,
  ...rest
}: {
  numeral: string;
  title: string;
  description: string;
  spanTwo?: boolean;
  [key: string]: unknown;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>();
  return <div ref={ref} {...rest} className={`group relative p-8 md:p-10 lg:p-12 border border-border backdrop-blur-md shadow-lg transition-all duration-500 ease-out hover:-translate-y-1.5 hover:shadow-xl ${spanTwo ? "lg:col-span-2" : ""} ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`} style={{
    backgroundColor: "var(--card)"
  }}>
      {}
      <div className="font-mono font-light leading-none mb-6 transition-all duration-500 group-hover:[text-shadow:0_0_30px_var(--primary)]" style={{
      fontSize: "4rem",
      color: "var(--primary)"
    }}>
        {numeral}
      </div>

      {}
      <div className="h-px w-full bg-border mb-6" />

      {}
      <h3 className="font-default font-bold text-foreground mb-4 leading-tight" style={{
      fontSize: "1.75rem"
    }}>
        {title}
      </h3>

      {}
      <p className="font-sans text-base leading-relaxed" style={{
      color: "var(--muted-foreground)"
    }}>
        {description}
      </p>

      {}
      <div className="absolute top-0 right-0 w-px h-12 transition-all duration-500 group-hover:h-20" style={{
      backgroundColor: "var(--primary)"
    }} />
    </div>;
}